// extracted by mini-css-extract-plugin
export default {"row":"editTask_row__9UERJ","col":"editTask_col__SJVYu","card":"editTask_card__BIAuz"};